<template>
	<Component
		:is="tag"
		class="card"
	>
		<slot />
	</Component>
</template>

<script>
export default {
	props: {
		tag: {
			type: String,
			default: 'div',
		},
	},
};
</script>

<style lang="scss" scoped>
.card {
	padding: 24px 32px;
	margin-bottom: 16px;
	overflow: hidden;
	background: $light;

	@include mobile-view {
		padding: 16px;
		margin-bottom: 8px;
	}
}

</style>
